import { useQuery } from '@tanstack/react-query';

import { getProductById } from '../api/getProductById';

export const useProductById = (
  id: string,
  options?: { refetchInterval?: number | false }
) => {
  const query = useQuery({
    queryKey: ['product', id],
    queryFn: async () => {
      const response = await getProductById(id);

      return response.data;
    },
    enabled: !!id,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchInterval: options?.refetchInterval ?? false
  });

  return query;
};
